/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { trainingServices } from '../../../../api/services/trainingServices';
import { setMyTrainingData } from '../../../../infra/aggregates/myProfile/TrainingAggregates/getMyTrainingSlice';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { DigitalSignature } from '../../../../api/services/digitalSignatureService';

interface PropsValues {
  setViewLogsData: (data: any) => void;
  id: any;
}

function DTOViewDigitalDocs({ setViewLogsData, id }: PropsValues) {
  const { t } = useTranslation();
  const selector = useAppSelector((state) => state.authSlice);
  const dispatch = useAppDispatch();

  async function getLogs() {
    const response: any = await DigitalSignature.getDigiSignLogs(
      selector?.company_id,
      id,
    );
    if (response) {
      setViewLogsData(response.data);
    }
  }
  useEffect(() => {
      getLogs();
  }, [id]);
  return <></>;
}
export default DTOViewDigitalDocs;
